var DocUtils = new function() {
    var self = this;

    publicConfiguration = (typeof(window) == 'undefined')? require("../config/public.conf.js"): publicConfiguration;

    var docFilters = [
        {
            name: 'hSignedDocLink',
            action: function(docId) {

                return DocUtils.getDocPath(docId, true);
            }
        },
        {
            name: 'hDocAttachmentLink',
            action: function (attachmentId, redirect, downloadMode) {
                return DocUtils.getAttachmentPath(attachmentId, true, downloadMode);
            }
        }
    ];

    /**
     * Get image path from params
     */
    self.getDocPath = function(docId, redirect) {

        var docSignedURL = publicConfiguration.OnboardingServerBaseURL + "get_signed_doc/"+docId;

        if(redirect){
            docSignedURL += '?redirect=false';
        }

        return 'redirectTo?link=' + encodeURIComponent(docSignedURL);
    };

    /**
     * Get image path from params
     */
    self.getAttachmentPath = function(attachmentId, redirect, downloadMode) {
        var $state = $injector.get('$state');
        var params = {};
        var attachmentURL = `${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment_url/${attachmentId}?`;
        if (redirect) {
            params["redirect"] = false;
        }
        if (downloadMode) {
            params["mode"] = 'DOWNLOAD';
        }
        attachmentURL += $.param(params);

        return $state.href('redirectTo') +'?link='+ encodeURIComponent(attachmentURL);
    };

    /**
     * Register filters for Angular and Nunjucks
     * @param environment
     */
    self.registerFilters = function(environment) {
        var envType;
        var addFilterFunc;
        if (typeof(environment.addFilter) == 'function') {
            envType = 'nunjucks';
        }
        else if (typeof(environment.filter) == 'function') {
            envType = 'angular';
            addFilterFunc = environment.filter;
        }

        if (!envType) {
            throw("Doc Utils: Unsupported environment given", environment);
        }


        docFilters.forEach(function(filter) {

            self[filter.name] = filter.action;

            switch (envType) {
                case 'angular':
                    environment.filter(filter.name, function() {
                        return filter.action
                    });
                    break;
                case 'nunjucks':
                    environment.addFilter(filter.name, filter.action);
                    break;
            }
        });
    }
}

//export public configuration to node.js app.
try {
    module.exports = DocUtils;
} catch (e) { }

if (typeof window != "undefined") {
    window.DocUtils = DocUtils;
}
